export default {"src":"/_next/static/media/c_Silver_1.41d80a27.svg","height":92,"width":88,"blurWidth":0,"blurHeight":0};